import { CuentaGiro } from '@/components/paginas/Cliente/Operacion/Resumen/models/cuentaGiro.model';
import { Domicilio } from '@/models/respuestas/domicilio.model';
import { Correo, Telefono } from '@/models/store/usuario.model';

// Constantes operacion
const OPERACIONES_FACTORING = 'Operaciones/Factoring';
const ADMIN = 'Admin';

//Feriados
export const OBTENER_FERIADOS = 'ObtenerFeriados';

//#region Simulación
const PARAMETROS = 'Parametros';
export const PARAMETROS_DOCUMENTOS = `${PARAMETROS}/Documentos`;
export const PARAMETROS_SIMULACIONES = (rut?: string) =>
  `${PARAMETROS}/Simulaciones${rut ? `?rut=${rut}` : ''}`;
//#endregion

//#region Crear Operación
// Listado DTES
export const DOCUMENTOS = 'Documentos';

// DTES en operaciones existentes
export const VALIDAR_DOCUMENTOS = 'Documentos/Validar';
// Guardar certificado
export const CERTIFICADO = 'Certificados';
export const CREAR_OPERACION = OPERACIONES_FACTORING;
//#endregion

//#region Listado
export const LISTADO_OPERACIONES_CLIENTE = OPERACIONES_FACTORING;
export const LISTADO_OPERACIONES_EJECUTIVO = `${ADMIN}/${OPERACIONES_FACTORING}`;
export const LISTADO_OPERACIONES_MIGRADAS_CLIENTE = (rut: string): string =>
  `${OPERACIONES_FACTORING}/ObtenerOperacionesMigradas?rut=${rut}`;
//#endregion

//#region Cuentas de giro
export const COMBO_BANCOS = 'Bancos/Combo';
export const CUENTAS = 'Cuentas';
export const BORRAR_CUENTA = (idCuenta: CuentaGiro['id']): string =>
  `${CUENTAS}/${idCuenta}`;
export const EDITAR_CUENTA = `${CUENTAS}/EditarCuenta`;
export const TIPO_CUENTAS_COMBO = 'TiposCuentas/Combo';
//#endregion

//#region Estados listado
export const COMBO_ESTADOS = 'EstadosOperacion/Factoring/Combo';
export const COMBO_COLORES_ESTADOS = 'EstadosOperacion/Factoring';
//#endregion

//#region Detalle operacion
export const ARCHIVO_OPERACION = (
  idOperacion: number,
  idDocumento: number,
  idArchivo: number
) =>
  `${ADMIN}/${OPERACIONES_FACTORING}/${idOperacion}/Documentos/${idDocumento}/Archivos/${idArchivo}/UrlDescarga`;

export const DESCARGAR_SIMULACION = (idOperacion: number) =>
  `${ADMIN}/${OPERACIONES_FACTORING}/${idOperacion}/Simulacion`;

export const ACTUALIZAR_VENCIMIENTO = `${ADMIN}/${OPERACIONES_FACTORING}/ActualizarFechaVencimiento`;

export const ALTERNAR_FACTURAS_DETALLE = `${ADMIN}/${OPERACIONES_FACTORING}/EliminarRestaurarFactura`;

//#region Administración de estados
export const DETALLES_OPERACION_CLIENTE = (idOperacion: number) =>
  `${OPERACIONES_FACTORING}/${idOperacion}`;
export const DETALLES_OPERACION_EJECUTIVO = (idOperacion: number) =>
  `${ADMIN}/${OPERACIONES_FACTORING}/${idOperacion}`;
export const APROBAR_OPERACION = (idOperacion: number) =>
  `${ADMIN}/${OPERACIONES_FACTORING}/${idOperacion}/Aprobar`;
export const RECHAZAR_OPERACION = (_idOperacion: number) =>
  `${ADMIN}/${OPERACIONES_FACTORING}/Rechazar`;
export const GIRAR_OPERACION = (_idOperacion: number) =>
  `${ADMIN}/${OPERACIONES_FACTORING}/EnviarAGiro`;
export const CEDER_OPERACION = (idOperacion: number) =>
  `${ADMIN}/${OPERACIONES_FACTORING}/${idOperacion}/Ceder`;
export const CEDER_OPERACION_MANUALMENTE = (idOperacion: number) =>
  `${ADMIN}/${OPERACIONES_FACTORING}/${idOperacion}/CederManualmente`;
export const AUTORIZAR_CESION = (idOperacion: number) =>
  `${OPERACIONES_FACTORING}/AutorizarCeder/${idOperacion}`;
//#endregion

//#endregion

//#region Perfil
const Perfil = 'Perfil';
export const OBTENER_PERFIL = `${Perfil}/ObtenerPerfil`;
export const TIPOS_TELEFONOS = `${Perfil}/ObtenerTiposDeTelefonos`;

export const CREAR_DIRECCION = `${Perfil}/CrearNuevaDireccion`;
export const CREAR_CORREO = `${Perfil}/CrearNuevoCorreo`;
export const CREAR_TELEFONO = `${Perfil}/CrearNuevoTelefono`;

export const OBTENER_REGIONES = `${Perfil}/ObtenerRegiones`;
export const OBTENER_PROVINCIAS = (idRegion: number) =>
  `${Perfil}/ObtenerProvincias?idRegion=${idRegion}`;
export const OBTENER_COMUNAS = (idProvincia: number) =>
  `${Perfil}/ObtenerComunas?idProvincia=${idProvincia}`;

export const EDITAR_CORREO = (id: Correo['idCorreo']) =>
  `${Perfil}/EditarCorreo?idCorreo=${id}`;
export const EDITAR_TELEFONO = (id: Telefono['idTelefono']) =>
  `${Perfil}/EditarTelefono?idTelefono=${id}`;
export const EDITAR_DIRECCION = (id: Domicilio['idDireccion']) =>
  `${Perfil}/EditarDireccion?idDireccion=${id}`;

export const ELIMINAR_CORREO = (id: Correo['idCorreo']) =>
  `${Perfil}/EliminarCorreo?idCorreo=${id}`;
export const ELIMINAR_TELEFONO = (id: Telefono['idTelefono']) =>
  `${Perfil}/EliminarTelefono?idTelefono=${id}`;
export const ELIMINAR_DIRECCION = (id: Domicilio['idDireccion']) =>
  `${Perfil}/EliminarDireccion?idDireccion=${id}`;

export const BANNER_HOME = 'Homeclientes/InformacionHomeClientes';

//#endregion

//#region Credenciales
const Personas = 'Usuarios/v1';
export const REGISTRAR_CUENTA = `${Personas}/SignUp`;
export const INICIAR_SESION = `${Personas}/SignIn`;
export const ENVIAR_RESTABLECER = `${Personas}/ForgotPassword`;
//#endregion

//#region Redirecciones
const Redirecciones = 'Redirecciones/v1';
export const VERIFICAR_CUENTA_CLIENTE = `${Redirecciones}/VerificarUsuario`;
export const VERIFICAR_CUENTA_EJECUTIVO = `${Redirecciones}/IngresarNewFactor`;
export const RESTABLECER_CONTRASEÑA = `${Redirecciones}/RestablecerPassword`;
//#endregion

//#region Enrolamiento
const Enrolamiento = 'Enrolamiento';
export const REGISTRAR_ENROLAMIENTO = `${Enrolamiento}/RegistrarEnrolamiento`;
export const ESTADO_ENROLAMIENTO = `${Enrolamiento}/VerificarEstadoEnrolamiento`;
//#endregion

//#region Asignacion ejecutivo
const AsignacionE = 'AsignarEjecutivoAdmin';
export const LISTADO_CLIENTES_ASIGNACION = (
  fechaInicio: string,
  fechaFin: string
) =>
  `${AsignacionE}/ListadoDeClientes?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`;
export const LISTADO_EJECUTIVOS = `${AsignacionE}/Ejecutivos`;
export const ASIGNAR_EJECUTIVO = `${AsignacionE}/AsignarEjecutivo`;
export const HISTORIAL_ASIGNACIONES_CLIENTE = (idCliente: number) =>
  `${AsignacionE}/HistorialAsignacionesPorCliente/${idCliente}`;
//#endregion

//#region Mantenedor clientes
const PerfilCliente = 'PerfilCliente';
const CLIENTES = 'Clientes';
export const LISTADO_CLIENTES_MANTENEDOR = (
  fechaInicio: string,
  fechaFin: string
) =>
  `${ADMIN}/${CLIENTES}/InformacionClientes?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`;
export const OBTENER_PERFIL_CLIENTE = (idCliente: number) =>
  `${ADMIN}/${PerfilCliente}/ObtenerPerfilCliente?idPersona=${idCliente}`;
export const DESCARGAR_ARCHIVO = (idCliente: number, idArchivo: number) =>
  `${ADMIN}/${CLIENTES}/DescargarArchivo?idArchivo=${idArchivo}&idCliente=${idCliente}`;
export const OBTENER_PREVIEW = (idCliente: number, idArchivo: number) =>
  `${ADMIN}/${CLIENTES}/${idCliente}/Archivos/${idArchivo}/UrlArchivo`;
export const SUBIR_ARCHIVO_CLIENTE = `${ADMIN}/${CLIENTES}/SubirArchivo`;
export const ELIMINAR_ARCHIVO_CLIENTE = (idArchivo: number) =>
  `${ADMIN}/${CLIENTES}/EliminarArchivo/${idArchivo}`;

//#endregion
